// src/services/api/tableColumns.js

// This file is auto-generated. Do not edit manually.

export const TABLE_COLUMNS = {
    dim_datacarptmanallowance: {
      primaryKey: 'datacarptmanallowance_id',
      columns: [
        'tradepersonid',
        'start_date',
        'end_date',
        'amount',
        'paid_on',
        'type',
        'ci_ref',
      ],
      editable: [
        'start_date',
        'end_date',
        'amount',
        'paid_on',
        'type',
        'ci_ref',
        // 'tradepersonid' is intentionally excluded to prevent editing
      ],
    },
    dim_datadailyfares: {
      primaryKey: 'datadailyfares_id',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_datahours: {
      primaryKey: 'datahoursid',
      columns: ['ord_hrs_per_day','ord_hrs_per_week'],
      editable: ['ord_hrs_per_day','ord_hrs_per_week'],
    },
    dim_dataincomeprotectionperweek: {
      primaryKey: 'data_income_protection_per_week_id',
      columns: [
        'tradepersonid',
        'type',
        'start_date',
        'end_date',
        'amount',
        'ci_ref',
        'per',
      ],
      editable: ['type', 'start_date', 'end_date', 'amount', 'ci_ref', 'per'],
    },
    dim_dataleadhand10: {
      primaryKey: 'dataleadhand_id',
      columns: ['tradepersonid', 'type', 'amount', 'start_date', 'end_date', 'ci_ref'],
      editable: ['type', 'amount', 'start_date', 'end_date', 'ci_ref'],
    },
    dim_dataotimemealallowance: {
      primaryKey: 'dataotimemealallowance_id',
      columns: [
        'tradepersonid',
        'start_date',
        'end_date',
        'amount',
        'ci_ref',
        'trigger',
        'type',
      ],
      editable: ['start_date', 'end_date', 'amount', 'ci_ref', 'trigger', 'type'],
    },
    dim_dataredundancycontribution: {
      primaryKey: 'redundancy_contribution_id',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_dataretentionpayment: {
      primaryKey: 'dataretentionpayment_id',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_datasideprodallowance: {
      primaryKey: 'datasideprodallowanceid',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_firstaidlevel3perday: {
      primaryKey: 'firstaidlevel3perdayid',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_overtime: {
      primaryKey: 'overtime_id',
      columns: [
        'ci_ref',
        'm_f_first_2_hrs',
        'm_f_after_2_hrs',
        'sat_first_2_hrs',
        'sat_after_2_hrs',
        'sun_otime',
      ],
      editable: [
        'ci_ref',
        'm_f_first_2_hrs',
        'm_f_after_2_hrs',
        'sat_first_2_hrs',
        'sat_after_2_hrs',
        'sun_otime',
      ],
    },
    dim_paidbreaks: {
      primaryKey: 'paidbreaksid',
      columns: [
        'm-f_morning_crib_break_ci_ref',
        'm-f_morning_crib_break_hours',
        'm-f_morning_crib_break_mins',
        'm-f_overtime_crib_break_ci_ref',
        'm-f_overtime_crib_break_hours_of_overtime',
        'm-f_overtime_crib_break_hours_of_break',
        'm-f_overtime_crib_break_mins',
        'm-f_overtime_crib_break_agree_to_payment_in_lieu_of',
        'm_f_overtime_crib_break_payment_rate',
        'm-f_overtime_crib_break_mon',
        'm-f_overtime_crib_break_tues',
        'm-f_overtime_crib_break_wed',
        'm-f_overtime_crib_break_thurs',
        'm-f_overtime_crib_break_friday',
        'sat_sun_pub_hol_first_crib_break_ci_ref',
        'sat_sun_pub_hol_first_crib_break_hours_of_overtime',
        'sat_sun_pub_hol_first_crib_break_hours_of_break',
        'sat_sun_pub_hol_first_crib_break_mins',

        'sat_sun_pub_hol_second_break_ci_ref',
        'sat_sun_pub_hol_second_break_hours_of_overtime',
        'sat_sun_pub_hol_second_break_hours_of_break',
        'sat_sun_pub_hol_second_break_mins',
        'sat_sun_pub_hol_second_break_payable_meal_break_hrs',
        'sat_sun_pub_hol_second_break_rate',
      ],
      editable: [
        'm-f_morning_crib_break_ci_ref',
        'm-f_morning_crib_break_hours',
        'm-f_morning_crib_break_mins',
        'm-f_overtime_crib_break_ci_ref',
        'm-f_overtime_crib_break_hours_of_overtime',
        'm-f_overtime_crib_break_hours_of_break',
        'm-f_overtime_crib_break_mins',
        'm-f_overtime_crib_break_agree_to_payment_in_lieu_of',
        'm_f_overtime_crib_break_payment_rate',
        'm-f_overtime_crib_break_mon',
        'm-f_overtime_crib_break_tues',
        'm-f_overtime_crib_break_wed',
        'm-f_overtime_crib_break_thurs',
        'm-f_overtime_crib_break_friday',
        'sat_sun_pub_hol_first_crib_break_ci_ref',
        'sat_sun_pub_hol_first_crib_break_hours_of_overtime',
        'sat_sun_pub_hol_first_crib_break_hours_of_break',
        'sat_sun_pub_hol_first_crib_break_mins',
        'sat_sun_pub_hol_second_break_ci_ref',
        'sat_sun_pub_hol_second_break_hours_of_overtime',
        'sat_sun_pub_hol_second_break_hours_of_break',
        'sat_sun_pub_hol_second_break_mins',
        'sat_sun_pub_hol_second_break_payable_meal_break_hrs',
        'sat_sun_pub_hol_second_break_rate',
      ],
    },
    dim_rates: {
      primaryKey: 'ratesid',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'ci_ref'],
    },
    dim_superannuation: {
      primaryKey: 'superannuationid',
      columns: ['start_date', 'end_date', 'super_rate'],
      editable: ['start_date', 'end_date', 'super_rate'],
    },
    dim_superminpayment: {
      primaryKey: 'superminpaymentid',
      columns: ['start_date', 'end_date', 'minimum_payment', 'ci_ref'],
      editable: ['start_date', 'end_date', 'minimum_payment', 'ci_ref'],
    },
    dim_toolallowance: {
      primaryKey: 'toolallowanceid',
      columns: ['tradepersonid', 'start_date', 'end_date', 'amount', 'type', 'ci_ref'],
      editable: ['start_date', 'end_date', 'amount', 'type', 'ci_ref'],
    },
    dim_type: {
      primaryKey: 'typeid',
      columns: ['typename'],
      editable: ['typename'],
    },
    dim_washup: {
      primaryKey: 'washupid',
      columns: ['WashupCI Ref', 'type', 'per', 'hoursid', 'minus'],
      editable: ['WashupCI Ref', 'type', 'per', 'hoursid', 'minus'],
    },
    fact_leave: {
      primaryKey: 'leaveid',
      columns: [
        'personal_leave_days',
        'annual_leave_days',
        'annual_leave_loading',
        'payout_on_termination',
      ],
      editable: [
        'personal_leave_days',
        'annual_leave_days',
        'annual_leave_loading',
        'payout_on_termination',
      ],
    },
  };
  